<template>
  <div>
    <el-menu class="navbar" mode="horizontal">
      <hamburger
        class="hamburger-container"
        :toggleClick="toggleSideBar"
        :isActive="sidebar.opened"
      ></hamburger>
      <breadcrumb></breadcrumb>
      <!-- <span style="margin: 10px  0px 0px 80% ;" v-if="imgavar">
        <img style="width：35px;height:35px" :src="imgavar" alt="" />
      </span>
      <el-avatar v-else size="medium" icon="el-icon-user-solid"></el-avatar> -->
      <!-- <i class="el-icon-bell hamburger" style=""></i> -->
      <template v-if="userId == 8">
        <div style="padding-left: 30px;">
          <span style="color: #409EFF;font-size: 14px;">图文问诊剩余：{{ textTimes }}次</span>
        </div>
        <div style="padding-left: 30px;">
          <span style="color: #409EFF;font-size: 14px;">视频问诊剩余：{{ videoTimes }}次</span>
        </div>
      </template>
      <el-dropdown class="avatar-container">
        <div class="avatar-wrapper">
          <!-- <img style="width：35px;height:35px" src="../../../assets/image/boy.png" alt=""> -->
          <span style="color: #333">欢迎您 , &nbsp;&nbsp;{{ name }}</span>
          <i
            class="el-icon-arrow-down el-icon--right"
            style="margin-botton: 10px"
          ></i>
        </div>
        <el-dropdown-menu class="user-dropdown" slot="dropdown" trigger="hover">
          <router-link class="inlineBlock" to="/">
            <el-dropdown-item>首页</el-dropdown-item>
          </router-link>
          <el-dropdown-item divided>
            <span @click="xiugai" style="display: block">修改密码</span>
          </el-dropdown-item>
          <!-- <el-dropdown-item divided>
            <span @click="qiehuan" style="display: block">切换部门</span>
          </el-dropdown-item> -->
          <el-dropdown-item divided>
            <span @click="logout" style="display: block">退出</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <!-- <el-dialog title="切换账号"
        :visible.sync="dialogVisible"
        width="60%"
        @before-close="dialogVisible = false">
        <el-table border :data="outDateList" v-loading="loading" element-loading-text="查询中请稍候">
                  <el-table-column prop="name" label="账号名" align="center"></el-table-column>
                  <el-table-column prop="type" label="账号类型" align="center">
                    <template slot-scope="scope">
                      <span>{{scope.row.type}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" align="center">
                 <template slot-scope="scope">
                     <el-button type="primary" size="mini" @click="modifyGoodsdialog(scope.row)">切换</el-button>
                 </template>    formLabelWidth
              </el-table-column>
                </el-table>
      </el-dialog>-->
    </el-menu>
    <div>
      <el-dialog title="修改密码" :visible.sync="dialogFormVisible" @close ="closeFrom">
        <el-form
          :model="ruleForm"
          status-icon
          :rules="rules"
          ref="ruleForm"
          label-width="130px"
          class="demo-ruleForm"
          width="50%"
        >
          <el-form-item label="旧密码" prop="oldpassword">
            <el-input type="password" v-model="ruleForm.oldpassword"
              autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="password">
            <el-input
              type="password"
              v-model="ruleForm.password"
              autocomplete="off"

            ></el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="confirmpassword">
            <el-input
              type="password"
              v-model="ruleForm.confirmpassword"
              autocomplete="off"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="resetForm('ruleForm')">重置</el-button>
          <el-button @click="closeFrom">取 消</el-button>
          <el-button type="primary" @click="submitForm('ruleForm')"
            >确 定</el-button
          >
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import Breadcrumb from "@/components/Breadcrumb";
import Hamburger from "@/components/Hamburger";

export default {
  data() {
    var validatejPass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入旧密码"));
      } else {
        if (this.ruleForm.oldpassword !== "") {
          this.$refs.ruleForm.validateField("oldpassword");
        }
        callback();
      }
    };
    var validatePass = (rule, value, callback) => {
      if (value === "" || value.length < 6) {
        callback(new Error("请输入密码不能小于6位"));
      } else {
        if (this.ruleForm.password !== "") {
          this.$refs.ruleForm.validateField("password");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.ruleForm.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      dialogVisible: false,
      dialogFormVisible: false,
      // realname: sessionStorage.getItem("realname")? sessionStorage.getItem("realname"): "",
      ruleForm: {
        id: "",
        username: "",
        oldpassword: "",
        password: "",
        confirmpassword: "",
      },
      rules: {
        oldpassword: [
          { required: true, message:'旧密码不能为空', trigger: "blur" },
          {
            required:true,
            pattern: /^[0-9A-Za-z]{6,20}$/,
            message: "请输入6到20位数字加字母",trigger: ["change","blur"]
          },
        ],
        password: [
          { required: true, message:'密码不能为空', trigger: "blur" },
          {
            required:true,
            pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/,
            message: "请输入6到20位数字加字母组合",trigger: ["change","blur"]
          },
        ],
        confirmpassword: [
          { required: true, validator: validatePass2, trigger: "blur" },
        ],
      },

      outDateList: [],
      loading: false,
      name: "",
      imgavar: "",
      listname: "",
      listtype: "",
      listId: "",
      textTimes: 0,
      videoTimes: 0,
      userId: null
    };
  },
  components: {
    Breadcrumb,
    Hamburger,
  },
  computed: {
    ...mapGetters(["sidebar", "avatar"]),
  },
  created() {
    this.name = localStorage.getItem("realname")
      ? localStorage.getItem("realname")
      : "";
    this.imgavar = localStorage.getItem("imgavar")
      ? localStorage.getItem("imgavar")
      : "";
    this.ruleForm.id = localStorage.getItem("id");
    this.ruleForm.username = localStorage.getItem("username");
    // console.log(33,localStorage.getItem("realname"),this.name)
    // let gongname = sessionStorage.getItem("listname")
    //   ? sessionStorage.getItem("listname")
    //   : "";
    //   if (gongname) {
    //     let Infolist = JSON.parse(gongname);
    //     console.log(Infolist);
    //     this.listtype = Infolist.type;
    //     this.listname = Infolist.name;
    //     this.listId = Infolist.storeId;
    //   }
    //   let list = sessionStorage.getItem("zhanghao")
    //     ? sessionStorage.getItem("zhanghao")
    //     : [];
    //   if (list && list.length == 0) {
    //     this.dialogVisible = false;
    //   }
    //   this.outDateList = JSON.parse(list);
    //   console.log(this.outDateList);
    let userId = localStorage.getItem("userIdentity");
    if(userId == 8) {
      this.userId = userId;
      this.init()
    }
  },
  methods: {
    init() {
      this.$api.get("/api/drugstoreConsultationConfig/queryDrugstoreConsultationCount").then((res) => {
        if (res.data.code === 200) {
          this.videoTimes = res.data.result.videoTimes;
          this.textTimes = res.data.result.textTimes;
        }
      });
    },
    closeFrom() {
      this.resetForm('ruleForm')
      this.dialogFormVisible = false
    },
    //修改密码
    xiugai() {
      this.dialogFormVisible = true;
    },
    submitForm() {

      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          let obj = {
            id: this.ruleForm.id,
            username: this.ruleForm.username,
            oldpassword: this.ruleForm.oldpassword,
            password: this.ruleForm.password,
            confirmpassword: this.ruleForm.confirmpassword,
          };
          this.$api.put("/sys/user/updatePassword", obj, true).then((res) => {
            if (res.data.success == true) {
              this.$message({
                message: "密码修改成功",
                type: "success",
              });
              this.closeFrom()
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    //切换账号
    modifyGoodsdialog(id) {
      // console.log(id);
      let uid = id.storeId;
      this.$api
        .post("/api/store/exchange/" + uid)
        .then((res) => {
          // console.log("quehuan", res.data);
          if (res.data.code == 400) {
            this.dialogVisible = false;
            this.$api.get("/api/account/current").then((res) => {
              this.name = res.data.results.account.username;
              let listInfo = res.data.results.current;
              this.listtype = res.data.results.current.type;
              this.listname = res.data.results.current.name;
              sessionStorage.setItem("username", this.name);
              sessionStorage.setItem("listname", JSON.stringify(listInfo));
              sessionStorage.setItem(
                "userInfo",
                JSON.stringify(res.data.results.account)
              );
              location.reload();
            });
          }
        })
        .catch((res) => {
          this.$message({
            message: "网络错误，请稍后重试",
            type: "error",
          });
        });
    },
    qiehuan() {
      this.dialogVisible = true;
    },
    toggleSideBar() {
      // console.log(111);
      this.$store.dispatch("ToggleSideBar");
    },
    logout() {
      // this.$api.get("/api/account/signout").then((res) => {
      //   console.log(res.data);
      //   if (res.data.code == 400) {
      //     sessionStorage.removeItem("token");
      //     this.$router.push({ path: "/login" });
      //   }
      // });
      // // this.$store.dispatch('LogOut').then(() => {
      // //   location.reload() // 为了重新实例化vue-router对象 避免bug
      // // })
      this.$confirm("真的要注销登录吗 ?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$router.push({ path: "/login" });

          let obj={
          online:'0'
        }
        this.$api
        .put("/shopKefu/changeUserOnline",obj,true)
        .then((res) => {
          this.$message({
            type: "info",
            message: "已成功退出",
          });
          this.tim.logout()
        })
           window.localStorage.removeItem('token');
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  height: 66px;
  line-height: 66px;
  border-radius: 0px !important;
  display: flex;
  .hamburger-container {
    line-height: 75px;
    height: 66px;
    float: left;
    padding: 0 10px;
  }

  .hamburger {
    display: inline-block;
    position: absolute;
    right: 160px;
    margin: 20px 30px 0px 0px;
  }
  .screenfull {
    position: absolute;
    right: 90px;
    top: 16px;
    color: red;
  }
  .avatar-container {
    height: 50px;
    display: inline-block;
    position: absolute;
    right: 35px;
    .avatar-wrapper {
      cursor: pointer;
      margin-top: 5px;
      position: relative;
      .user-avatar {
        width: 40px;
        height: 40px;
        border-radius: 10px;
      }
      .el-icon-caret-bottom {
        position: absolute;
        right: -20px;
        top: 25px;
        font-size: 12px;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue